import { useState } from 'react';
import { useAsync } from 'react-async-hook';
import AwesomeDebouncePromise from 'awesome-debounce-promise';
import useConstant from 'use-constant';
import { AxiosResponse } from 'axios';


type DebounceOptions = {
    defaultValue: any,
    wait: number,
    minLength: number,
}

const useDebouncedSearch = (searchFunction: (input: string) => Promise<AxiosResponse>, options?: Partial<DebounceOptions>) => {
    const [input, setInput] = useState('');

    // Debounce the original search async function
    const debouncedSearchFunction = useConstant(() =>
        AwesomeDebouncePromise(searchFunction, options?.wait || 500)
    );

    // The async callback is run each time the text changes,
    // but as the search function is debounced, it does not
    // fire a new request on each keystroke
    const promise = useAsync(
        async () => {
            if (input.length < (options?.minLength || 1)) {
                return options?.defaultValue;
            } else {
                return debouncedSearchFunction(input);
            }
        },
        [debouncedSearchFunction, input]
    );

    return {
        input,
        setInput,
        promise,
    };
};

export default useDebouncedSearch;
